import {
  DndContext,
  type DndContextProps,
  KeyboardSensor,
  MouseSensor,
  PointerSensor,
  TouchSensor,
  closestCenter,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  type SortableContextProps,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { Box, type BoxProps } from '@mui/material';
import DndOverlay from './DndOverlay';

type Props = {
  dndContextProps?: DndContextProps;
  boxProps?: BoxProps;
  dndOverlay?: boolean;

  sortableContextProps: Omit<SortableContextProps, 'children'>;
  children: React.ReactNode;
};

const SortableContainer = (props: Props) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    })
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      modifiers={[restrictToVerticalAxis]}
      {...props?.dndContextProps}
    >
      <Box {...props?.boxProps}>
        <SortableContext strategy={verticalListSortingStrategy} {...props.sortableContextProps}>
          {props.children}
        </SortableContext>
        {props?.dndOverlay !== false && <DndOverlay />}
      </Box>
    </DndContext>
  );
};

export default SortableContainer;
